module.exports = __webpack_public_path__ + "img/dashuju.356c5178.png";